import { isFunction } from 'lodash';

export const showColumn = (column: Recordable) => {
  if (column.render) {
    return false;
  }
  if (
    column.formatter &&
    !(column.showTooltip && isFunction(column.formatter))
  ) {
    // formatter和showTooltip同时存在时使用template渲染，并且formatter必须是函数
    return false;
  }
  return true;
};

// 图片使用width，当表格又剩余宽度时不等比例放大
export const getColumnWidth = (column: Recordable) => {
  if ((column.useWidth || column?.type === 'image') && column?.width)
    return column.width;
  return undefined;
};

// 滚动要指定列（减去固定列
export const scrollToColumnByField = (
  tableRef: any,
  columns: Recordable,
  field: string
) => {
  try {
    if (!tableRef || !columns?.length || !field) return;
    const column = tableRef?.getColumnByField(field);
    const tdElem = tableRef?.$el?.querySelector('.'.concat(column?.id));
    if (!tdElem) return;
    const leftFixedWidth = columns
      .filter((item: Recordable) => item.fixed === 'left')
      .reduce((total: number, item: any) => {
        if (item.fixed === 'left') {
          total += item.width || 120;
        }
        return total;
      }, 0);
    // 减掉左侧固定列宽
    tableRef.scrollTo(tdElem.offsetLeft - leftFixedWidth);
  } catch (error) {
    console.error(error);
  }
};
